import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export function LogoutButton({ extraClassName = "" }: { extraClassName?: string }) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <button type="button" className={`results__logout ${extraClassName}`} onClick={handleLogout}>
      Sair
    </button>
  );
}
